class HomepageHeroComponent extends HTMLElement {
  constructor() {
    super();
    this.onSlideChange = this.onSlideChange.bind(this);
  }

  connectedCallback() {
    this.slideshow = this.querySelector('slideshow-component');
    this.slider = this.querySelector('[data-homepage-hero-slider]');

    if (!this.slideshow || !this.slider) return;

    this.querySelectorAll('video').forEach((video) => {
      video.setAttribute('playsinline', '');
      video.muted = true;
    });

    this.slider.addEventListener('scroll', this.onSlideChange, { passive: true });
    this.slideshow.addEventListener('slideChanged', this.onSlideChange);
    this.pauseInactiveVideos();

    window.setTimeout(() => this.pauseInactiveVideos(), 150);
  }

  disconnectedCallback() {
    if (this.slider) {
      this.slider.removeEventListener('scroll', this.onSlideChange);
    }
    if (this.slideshow) {
      this.slideshow.removeEventListener('slideChanged', this.onSlideChange);
    }
  }

  onSlideChange() {
    window.requestAnimationFrame(() => this.pauseInactiveVideos());
  }

  pauseInactiveVideos() {
    const slides = this.slider.querySelectorAll('.homepage-hero__slide');
    if (!slides.length) return;

    let activeIndex = 0;
    const sliderRect = this.slider.getBoundingClientRect();
    const sliderCenter = sliderRect.left + sliderRect.width / 2;

    slides.forEach((slide, index) => {
      const slideRect = slide.getBoundingClientRect();
      const slideCenter = slideRect.left + slideRect.width / 2;

      if (Math.abs(slideCenter - sliderCenter) < slideRect.width / 2) {
        activeIndex = index;
      }
    });

    slides.forEach((slide, index) => {
      const video = slide.querySelector('video');
      if (!video) return;

      if (index === activeIndex) {
        video.play().catch(() => {});
      } else {
        video.pause();
        video.currentTime = 0;
      }
    });
  }
}

customElements.define('homepage-hero-component', HomepageHeroComponent);
